import React from 'react'
import {KTSVG} from '../../../../../../../_metronic/helpers'
import {MyContext} from '../../ContextFile'
import {useListView} from '../../core/ListViewProvider'
import {CouponListFilter} from './CouponListFilter'
import {useNavigate} from 'react-router-dom'

const CouponListToolbar = () => {
  const {setItemIdForUpdate} = useListView()
  const {state, setState} = React.useContext(MyContext)
  const navigate = useNavigate()

  const openAddUserModal = () => {
    setItemIdForUpdate(null)
      setState({
        ...state,
        id: '', 
        code: '',
        description:'',
        discount_type: 'Percentage',
        discount_value: 0,
        min_purchase_amount: 0,
        max_discount_amount: 0,
        start_date: '',
        end_date: '',
        usage_limit: 0,
        status: 1,
        editclicked: false 
      })
      navigate('/coupon/add')
  }

  return (
    <div className='d-flex justify-content-end' data-kt-user-table-toolbar='base'>
      {/* <CouponListFilter /> */}

      {/* begin::Add user */}
      <button type='button' className='btn btn-primary' onClick={openAddUserModal}>
        <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-2' />
        Add Coupon
      </button>
      {/* end::Add user */}
    </div>
  )
}

export {CouponListToolbar}
